  <div>
    <spinner [id]="'mis'" [show]='activeSpinner'></spinner>
    <!-- <div class="float-left my-1 ml-10">
      <label>{{'datasubmitlevel.datasubmit' | translate}}</label>
      <select [(ngModel)]="datasubmitstate" disabled="" (change)="dataSubmissionChange()" class="form-control custom-selectbox selectdis">
          <option value="statewise" >{{'datasubmitlevel.statelevel' | translate}}</option>
      </select>
   </div> &nbsp;&nbsp; -->

    <div class="row">
      <div class="col-12 col-xl col-md-6">
        <div>
          <label>{{'header.year' | translate }}<span class="text-star">*</span></label>
          <select placeholder="Select Year" [(ngModel)]="filterOptions['assesmentyear']"
            class="form-control custom-selectbox">
            <option *ngFor="let year of yearDropDownList" value="{{year}}">{{year}}</option>
          </select>
        </div>
      </div>
      <div class="col-12 col-xl col-md-6">
        <label>{{'header.monthsmapping' | translate }}<span class="text-star">*</span></label>
        <select [(ngModel)]="monthlist['montharray']" (change)="selectOption($event.target.value)"
          class="form-control custom-selectbox">
          <option value="" [disabled]="true">{{'monthmaps.selcecttag' | translate }}</option>
          <option *ngFor="let month of monthsList" [value]="month.key">
            {{'monthmaps.' + month['value'] | translate}}</option>
        </select>
      </div>

      <div class="col-12 col-xl col-md-6" *ngIf="activeTab=='smartchart'">
        <div>
          <label>{{'header.state' | translate}}<span class="text-star">*</span></label>
          <!-- <div ng-if="!unready" ng-dropdown-multiselect="" options="filterDropDownLists['GroupList']" selected-model="filterlist['state']" extra-settings="dropdownSettings" translation-texts="{
        'checkAll': ('selectAll' | translate),
        'uncheckAll': ('selectNone' | translate),
        'buttonDefaultText': ('selectZero' | translate),
        'selectionCount': ('selectCount' | translate),
        'dynamicButtonTextSuffix': ('selectSufix' | translate)
        }">
       </div> -->
          <div *ngIf="selectedlanguage=='en'">
            <ng-multiselect-dropdown placeholder="{{ 'districtsdata.select' | translate}}"
              [data]="filterDropDownLists['GroupList']" [(ngModel)]="filterlist['state']" [settings]="dropdownSettings"
              (onSelect)="onItemSelect($event,'statelists')" (onSelectAll)="onSelectAll($event,'statelists')"
              (onDeSelect)="onItemDeSelect($event,'statelists')"
              (onDeSelectAll)="onItemDeSelectAll($event,'statelists')"
              translation-texts="{'selectAll': ('selectAll' | translate)}">
            </ng-multiselect-dropdown>
          </div>
          <div *ngIf="selectedlanguage=='hi'">
            <ng-multiselect-dropdown placeholder="{{ 'districtsdata.select' | translate}}"
              [data]="filterDropDownLists['GroupList']" [settings]="hindidropdownSettings"
              (onSelect)="onItemSelect($event,'statelists')" (onSelectAll)="onSelectAll($event,'statelists')"
              (onDeSelect)="onItemDeSelect($event,'statelists')"
              (onDeSelectAll)="onItemDeSelectAll($event,'statelists')"
              translation-texts="{'selectAll': ('selectAll' | translate)}">
            </ng-multiselect-dropdown>
            <!-- [(ngModel)]= "filterlist['state']"  -->
          </div>
        </div>
      </div>
      <!-- <div class="col-12 col-xl col-md-6">
        <div>
          <label>{{'header.year' | translate }}<span class="text-star">*</span></label>
          <select placeholder="Select Year" [(ngModel)]="filterOptions['assesmentyear']"
            class="form-control custom-selectbox">
            <option *ngFor="let year of yearDropDownList" value="{{year}}">{{year}}</option>
          </select>
        </div>
      </div> -->
      <div class="col-12 col-xl col-md-6" *ngIf="activeTab == 'customranking'">
        <div>
          <label>{{'header.state' | translate }}<span class="text-star">*</span></label>
          <select placeholder="Select State" [(ngModel)]="SelectedState" (change)="showdistrictdropdown(SelectedState)"
            class="form-control custom-selectbox">
            <option value=undefined>{{'tabledataforstates.selectstate' | translate}}</option>
            <option *ngFor="let state of statelists" value="{{state.uuid}}">
              {{'tabledataforstates.'+ state['name'] | translate}}</option>
          </select>
        </div>
      </div>
      <div class="col-12 col-xl col-md-6"
        *ngIf="(activeTab == 'comparison' || activeTab == 'indicatorchart'|| activeTab == 'themechart')">
        <div>
          <label>{{'header.state' | translate }}<span class="text-star">*</span></label>
          <select placeholder="Select State" [(ngModel)]="selectedstate" (change)="showdatafordist(selectedstate)"
            class="form-control custom-selectbox">
            <option value=undefined>{{'tabledataforstates.selectstate' | translate}}</option>
            <option *ngFor="let state of statelists" value="{{state.uuid}}">
              {{'tabledataforstates.'+ state['name'] | translate}}</option>
          </select>
        </div>
      </div>
      <div class="col-12 col-xl col-md-6"
        *ngIf="(activeTab == 'comparison' || activeTab == 'indicatorchart'|| activeTab == 'themechart') && showdistdrop">
        <div>
          <label>{{'header.district' | translate}}<span class="text-star">*</span></label>
          <select placeholder="Select District" [(ngModel)]="selectedlu" (change)="getdistuuid(selectedlu)"
            class="form-control custom-selectbox">
            <option value=undefined>{{'header.selecttag' | translate}}</option>
            <option *ngFor="let data of DistrictentityList" value="{{data.uuid}}">
              {{'districtsdata.'+ data['name'] | translate}}</option>
          </select>
        </div>
      </div>
      <div class="col-12 col-xl col-md-6" *ngIf="activeTab == 'comparison'">
        <div>
          <label>{{'header.selectbasetag' | translate}}<span class="text-star">*</span></label>
          <select placeholder="Select State" [(ngModel)]="baseselectedlu" (change)="showbasestatedata(baseselectedlu)"
            class="form-control custom-selectbox">
            <option value=undefined>{{'header.selectbasetag' | translate}}</option>
            <option *ngFor="let state of statelists" value="{{state.uuid}}">
              {{'tabledataforstates.'+ state['name'] | translate}}</option>
          </select>
        </div>
      </div>
      <div class="col-12 col-xl col-md-6" *ngIf="activeTab == 'comparison' && showbasedist">
        <div>
          <label>{{'header.basedist' | translate}}<span class="text-star">*</span></label>
          <select placeholder="Select State" [(ngModel)]="selectedbaseluuid"
            (change)="getdistbaseuuid(selectedbaseluuid)" class="form-control custom-selectbox">
            <option value=undefined>{{'header.selcteddist' | translate}}</option>
            <option *ngFor="let data of baseDistrictentityList" value="{{data.uuid}}">
              {{'districtsdata.'+ data['name'] | translate}}</option>
          </select>
        </div>
      </div>
      <div class="col-12 col-xl col-md-6" *ngIf="activeTab == 'customranking' && showdistdrop">
        <div>
          <label>{{'header.district' | translate}}<span class="text-star">*</span></label>
          <div *ngIf="selectedlanguage=='en'">
            <ng-multiselect-dropdown placeholder=" {{ 'districtsdata.select' | translate}}" [data]="districtentityList"
              class="text-white" [settings]="dropdownSetting" (onSelect)="onItemSelects($event)"
              (onSelectAll)="onSelectAlls($event)" (onDeSelect)="onItemDeSelects($event)"
              (onDeSelectAll)="onItemDeSelectAlls($event)">
              <!-- [(ngModel)]="districtArray" -->
            </ng-multiselect-dropdown>
          </div>
          <div *ngIf="selectedlanguage=='hi'">
            <ng-multiselect-dropdown placeholder=" {{ 'districtsdata.select' | translate}}" [data]="districtentityList"
              class="text-white" [settings]="hindidropdownSetting" (onSelect)="onItemSelects($event)"
              (onSelectAll)="onSelectAlls($event)" (onDeSelect)="onItemDeSelects($event)"
              (onDeSelectAll)="onItemDeSelectAlls($event)">
            </ng-multiselect-dropdown>
          </div>

        </div>
      </div>
      <div class="col-12 col-xl col-md-6" *ngIf="activeTab == 'customranking' || activeTab=='indicatorchart'">
        <div>
          <label>{{'misviewtabs.indlist' | translate}}<span class="text-star">*</span></label>
          <div *ngIf="selectedlanguage=='en'">
            <ng-multiselect-dropdown *ngIf="activeTab=='customranking'"
              placeholder=" {{ 'districtsdata.select' | translate}}" [data]="filterDropDownList['IndicatorList']"
              [settings]="dropdownSettings" (onSelect)="onItemSelect($event,'indicatorarray')"
              (onSelectAll)="onSelectAll($event,'indicatorarray')"
              (onDeSelect)="onItemDeSelect($event,'indicatorarray')"
              (onDeSelectAll)="onItemDeSelectAll($event,'indicatorarray')">
            </ng-multiselect-dropdown>
            <!-- [(ngModel)]="filterOptions['indicatorarray']" -->
          </div>
          <div *ngIf="selectedlanguage=='hi'">
            <ng-multiselect-dropdown *ngIf="activeTab=='customranking'"
              placeholder=" {{ 'districtsdata.select' | translate}}" [data]="filterDropDownList['IndicatorList']"
              [settings]="hindidropdownSettings" (onSelect)="onItemSelect($event,'indicatorarray')"
              (onSelectAll)="onSelectAll($event,'indicatorarray')"
              (onDeSelect)="onItemDeSelect($event,'indicatorarray')"
              (onDeSelectAll)="onItemDeSelectAll($event,'indicatorarray')">
            </ng-multiselect-dropdown>
            <!-- [(ngModel)]="filterOptions['indicatorarray']"  -->
          </div>
          <select *ngIf="activeTab=='indicatorchart'" placeholder="Select Indicator"
            class="form-control custom-selectbox" style="width:98%" [(ngModel)]="filterOptions['indicatorarray']">
            <option value="">{{'misviewtabs.selectindlist' | translate}}</option>
            <option *ngFor="let ind of indicatorentityList" value="{{ind.entityUUID}}">{{ind.sno}}
              {{'indicatorlist.' + ind['label'] | translate}}</option>
          </select>
        </div>
      </div>
      <div class="col-12 col-xl col-md-6" *ngIf="activeTab=='themechart'">
        <label>{{'datasubmitlevel.theme' | translate }}<span class="text-star">*</span></label>
        <select placeholder="Select Theme" class="form-control custom-selectbox"
          [(ngModel)]="filterOptions['themearray']" class="form-control custom-selectbox">
          <option value="">{{'datasubmitlevel.selecttheme' | translate }}</option>
          <option *ngFor="let theme of themeentityList" value="{{theme.entityUUID}}">
            {{'themedataObj.' + theme['label'] | translate}}</option>
        </select>


      </div>

      <div class="col-auto d-flex justify-content-start align-items-end"
        *ngIf="activeTab != 'customranking'&& activeTab!='indicatorstatus'">
        <button type="button" (click)="submitfilter()"
          class="btn btn-info pointer">{{'misviewtabs.submit' | translate}}</button>
      </div>

      <!-- <div class="col-1" *ngIf="activeTab =='indicatorstatus' &&  userdetails && (userdetails['roles'][0] == 'VALIDATION_AGENCY' || userdetails['roles'][0] == 'ADMIN')">  

            <button type="button" (click)="submitfilter()" class="btn btn-info pointer" style="margin-top:30px;">SUBMIT</button>
        </div> -->
      <div class="col-auto d-flex justify-content-start align-items-end"
        *ngIf="activeTab =='indicatorstatus' &&  userdetails && (userdetails['roles'][0] == 'VALIDATION_AGENCY' || userdetails['roles'][0] == 'ADMIN')">

        <button type="button" (click)="submitfilter()"
          class="btn btn-info pointer">{{'misviewtabs.submit' | translate}}</button>
      </div>


      <div class="col-auto d-flex justify-content-start align-items-end" *ngIf="activeTab == 'customranking'">
        <button type="button" (click)="submitfilter()"
          class="btn btn-info pointer">{{'misviewtabs.grank' | translate}}</button>
      </div>
    </div>

  </div>
